import { connect } from 'react-redux';
import { selectActiveVenueId } from 'selectors/general';

import ScheduleConflictsModal from './ScheduleConflictsModal';

const mapStateToProps = (state, ownProps) => ({
  venueId: selectActiveVenueId(state),
  ...ownProps,
});

export default connect(mapStateToProps)(ScheduleConflictsModal);
